import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getStoreFilters } from './../../../apis/requests';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useLang from "../../../hooks/useLang";
import BrandsLoader from './../brands/BrandsLoader';
import { isMobile } from 'react-device-detect';

const Categories = () => {
    const { t } = useTranslation();
    const lang = useLang();
    const { data, isLoading } = useQuery({
        queryKey: ["getShopFilters"],
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false,
        queryFn: () => {
            return getStoreFilters();
        },
    });
    const filters = data?.data.filters || undefined;

    return (
        <div>
            <div className="p-6 lg:py-10 py-6 my-6">
                <div className="text-center">
                    <h1 className="text-4xl font-semibold text-[#004040]">Shop by Category</h1>
                    <h2 className="text-xl font-medium py-2">Explore a wide range of products organized to help you find exactly what you need.</h2>
                </div>
            </div>
            <div className="mx-4 mb-5">
                {
                    isLoading &&
                    <BrandsLoader />
                }
                <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
                    {
                        !isLoading &&
                        filters.categories.map((category) => {
                            return (
                                <div key={category.id}>
                                    <Link
                                        to={"/shop/category/" + category.id + "/" + (lang === "en" ? category.category_name : category.category_name_ar)}
                                    >
                                        <img
                                            className="rounded-xl"
                                            loading="lazy"
                                            src={category.category_image}
                                            alt={category.brand_name}
                                        />
                                        <div className="flex items-center gap-2 my-2 text-[#004040]">
                                            <span className="font-bold text-[#004040]">{lang === "en" ? category.category_name : category.category_name_ar}</span>
                                            <span className="material-symbols-outlined">
                                                {lang === "en" ? "arrow_right_alt" : "arrow_left_alt"}
                                            </span>
                                        </div>
                                    </Link>
                                    {
                                        !isMobile &&
                                        <div>
                                            <ul className={"mx-2"}>
                                                {category.sub_categories.map((subc) => (
                                                    <li key={subc.id}>
                                                        <Link
                                                            to={"/shop/sub-category/" + subc.id + "/" + (lang === "en" ? subc.category_name : subc.category_name_ar)}
                                                            className="block my-1 hover:text-[#004040] text-sm font-semibold"
                                                        >
                                                            {lang === "en" ? subc.category_name : subc.category_name_ar}
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    }

                                </div>
                            );
                        })
                    }
                </div>
            </div>
        </div>
    );
}

export default Categories;